import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { SET_DROPDOWN_MENU_ITEMS_LIST } from "../../actions/types";
import { CoreService, TransactionsService, TransferAtSourceService } from "../../services";
import { TransferAtSourceEdit } from './components';
import 'date-fns';
import clsx from 'clsx';
import DateFnsUtils from '@date-io/date-fns';
import * as yup from 'yup';
import { Form, Formik, useFormik, useFormikContext } from 'formik';
import { ConfirmDialog, SuccessDialog } from '../../components/shared';
import { ActionButton, ButtonColor, HtmlTooltip } from '../../components/controls';
import { makeStyles } from '@material-ui/core/styles';
import { Backdrop, Box, Button, Card, CardContent, CardHeader, CircularProgress, Collapse, Container, Dialog, DialogActions, DialogContent, DialogTitle, Grid, MenuItem, FormControl, IconButton, InputAdornment, InputLabel, LinearProgress, OutlinedInput, Paper, Table, TableContainer, TableBody, TableCell, TableHead, TableRow, TextareaAutosize, TextField, Tooltip, Typography } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { DataGrid, GridRowsProp, GridColDef } from '@material-ui/data-grid';
import { ChevronDown, ChevronUp, CogOutline, HelpCircleOutline, Magnify, OpenInNew, TrashCan } from "mdi-material-ui";
import { orange, red, green, grey } from '@material-ui/core/colors';
import allowAction from '../../helpers/allowAction';

let validationSchema = yup.object({
    operationTeam: yup.string().required("Select an Operation Team"),
});
export default function MaterialReceivingCreate() {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();

    const [isLoading, setIsLoading] = useState(false);
    const [submitButton, setSubmitButton] = useState({ disabled: true, loading: false });
    const [submitButtonAfterWarning, setSubmitButtonAfterWarning] = useState({ disabled: false, loading: false });

    const dropdownItemsStore = useSelector((state) => state.dropdownMenuItems);
    const [dropdownMenuItems, setDropdownMenuItems] = useState({ sapStorageLocation: [], sapPlant: [], operationTeam: [], vehicleType: [] });
    const [dropdownStorageLocation, setDropdownStorageLocation] = useState([{ text: "Select a Plant first", value: "" }]);
    const [editTicketData, setEditTicketData] = useState({ ticketId: "", coTicketId: "", operationTeam: "", slocTo: "", plantTo: "", tankTo: "", batchNoTo: "", loadingDate: new Date().toISOString(), poNo: "", poItemNo: "", materialNo: "", vendorName: "", transportCom: "", truckNo: "", factoryName: "", vendorDoNo: "", vendorDoWeight: "", weightIn: "", weightOut: "", netWeight: "", slocFrom: "", plantFrom: "", tankFrom: "", batchNoFrom: "", createBy: "", createDate: null, modBy: "", modDate: null, status: "", sent: "", vehicleType: "", unit: "", materialName: "", comments: "", gainLoss: "", confirmWith: "", netWeightDest: "" });
    const dateNow = new Date();

    // Table
    const [searchedTable, setSearchedTable] = useState("");
    const [transactions, setTransactions] = useState([]);
    const [filteredTransactions, setFilteredTransactions] = useState([]);
    const [selectionModel, setSelectionModel] = React.useState([]);

    // Form
    const [autocompleteData, setAutocompleteData] = useState({ plant: { text: "", value: "" }, storage: { text: "", value: "" }, operationTeam: { text: "", value: "" }, vehicleType: { text: "", value: "" }, tankTo: { text: "", value: "" }, unit: { text: "", value: "" }, confirmWith: { text: "", value: "" }, gainLoss: { text: "", value: "" } })
    const [formData, setFormData] = useState({ loadingDate: new Date().toISOString(), operationTeam: '' });
    //Excel data
    const [rawExcelData, setRawExcelData] = useState("");
    const [loadingExcelImport, setLoadingExcelImport] = useState(false);
    const [successExcelImport, setSuccessExcelImport] = useState(false);
    const [errorsExcelImport, setErrorsExcelImport] = useState([]);
    const [warningErrorsExcelImport, setWarningErrorsExcelImport] = useState([]);
    const [excelDataFormIsEmpty, setExcelDataFormIsEmpty] = useState('none');

    // Dialogs
    const [openImportExcelDialog, setOpenImportExcelDialog] = useState(false);
    const [openImportExcelErrorDialog, setOpenImportExcelErrorDialog] = useState(false);
    const [openEditDialog, setOpenEditDialog] = useState(false);
    const [hasErrors, setHasErrors] = useState({ fatal: false, warning: false })
    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, title: '', subTitle: '' })
    const [successDialog, setSuccessDialog] = useState({ isOpen: false, title: '', subTitle: '' })
    const [dialogErrorMessage, setDialogErrorMessage] = useState({
        title: 'Excel data errors',
        text1: 'Fatal Data errors in the Excel sheet prevent their import.',
        text2: 'Please correct the errors and resubmit',
        color: 'error'
    });

    const formik = useFormik({
        initialValues: {
            loadingDate: new Date(),
            operationTeam: '',
        },
        validationSchema: validationSchema,
        onSubmit: values => {
            setFormData(values);
            setOpenImportExcelDialog(true);
            setLoadingExcelImport(false);
        },
    });

    useEffect(() => {
        /* Retreive dropdown if they are not already in the Redux store*/
        let dropdownToGet = ['sapPlant', 'operationTeam', 'vehicleType', 'sapStorageLocation', 'status', 'unit', 'tank', 'sapMaterial', 'yesNo', 'sourceDestination']
        let dropdownNotInTheStore = [];
        for (var key in dropdownItemsStore) {
            if (dropdownItemsStore[key].length === 0 && dropdownToGet.includes(key)) {
                dropdownNotInTheStore.push(key);
            }
        }
        if (dropdownNotInTheStore.length > 0) {
            setIsLoading(true);
            CoreService.dropdownItems(dropdownNotInTheStore).then(
                (response) => {
                    if (response) {
                        const data = response.data;
                        dispatch({
                            type: SET_DROPDOWN_MENU_ITEMS_LIST,
                            payload: data,
                        });
                    }
                    setIsLoading(false);
                });
        }
    }, [dropdownItemsStore, dispatch]);

    const rows: GridRowsProp = filteredTransactions;
    const columns: GridColDef[] = [
        {
            field: 'action', headerName: 'ACTION', width: 100, headerClassName: 'import-from-excel-table--header', align: 'center',
            renderCell: (params: GridCellParams) => {
                const onClickEdit = () => {
                    setEditTicketData(params.row);
                    setOpenEditDialog(true);
                };
                const onDelete = () => {
                    TransactionsService.deleteTransaction(params.id).then((response) => {
                        setConfirmDialog({ isOpen: false });
                        setTransactions(filteredTransactions.filter(row => row.ticketId !== params.id));
                        setFilteredTransactions(filteredTransactions.filter(row => row.ticketId !== params.id))
                    })
                };
                const onClickDelete = () => {
                    setConfirmDialog({
                        isOpen: true,
                        title: 'Are you sure',
                        subTitle: <><Box component="div">Do you really want to remove this record ?</Box><Box component="div">This process cannot be undone</Box></>,
                        onConfirm: () => { onDelete() }
                    })
                };
                return (<>
                    <IconButton aria-label="update" className={classes.margin} size="small" onClick={onClickEdit}>
                        <CogOutline />
                    </IconButton>
                    {allowAction("20101", "cancel")}
                    <IconButton aria-label="delete" className={classes.margin} size="small" onClick={onClickDelete}>
                        <TrashCan />
                    </IconButton>
                </>);
            },
        },
        {
            field: 'ticketId', headerName: 'TICKET ID', width: 160, headerClassName: 'import-from-excel-table--header',
        },
        {
            field: 'loadingDate', headerName: 'LOADING DATE', width: 150, headerClassName: 'import-from-excel-table--header',
            valueFormatter: (params: ValueFormatterParams) => (new Date(params.value)).toLocaleDateString('fr-FR', { year: 'numeric', month: '2-digit', day: '2-digit' })
        },
        {
            field: 'status', headerName: 'STATUS', width: 140, align: 'center', headerClassName: 'import-from-excel-table--header',
            cellClassName: (params) => clsx('import-from-excel-table', {
                error: params.value === 'Error',
                success: params.value === 'Success',
            }),
            valueFormatter: (params: ValueFormatterParams) => dropdownItemsStore["status"].filter(function (status) {
                return status.value === params.value;
            })[0].text,
        },
        { field: 'truckNo', headerName: 'TRUCK NO/VESSEL', width: 300, headerClassName: 'import-from-excel-table--header' },
        { field: 'materialNo', headerName: 'MATERIAL', width: 120, headerClassName: 'import-from-excel-table--header' },
        { field: 'materialName', headerName: 'MATERIAL NAME', width: 120, headerClassName: 'import-from-excel-table--header' },
        { field: 'slocFrom', headerName: 'SOURCE LOCATION', width: 120, headerClassName: 'import-from-excel-table--header' },
        { field: 'plantFrom', headerName: 'SOURCE PLANT', width: 140, headerClassName: 'import-from-excel-table--header' },
        { field: 'slocTo', headerName: 'DEST. LOCATION', width: 140, headerClassName: 'import-from-excel-table--header' },
        { field: 'plantTo', headerName: 'DEST. PLANT', width: 140, headerClassName: 'import-from-excel-table--header' },
        { field: 'netWeight', headerName: 'SOURCE WEIGHT', width: 140, headerClassName: 'import-from-excel-table--header' },
        { field: 'operationTeam', headerName: 'OPERATION TEAM', width: 140, headerClassName: 'import-from-excel-table--header' },
    ];

    const handleImportExcelDialogClose = () => {
        setOpenImportExcelDialog(false);
    };
    const handleImportExcelErrorDialogClose = () => {
        setOpenImportExcelErrorDialog(false);
    };
    const handleEditDialogClose = () => {
        setOpenEditDialog(false);
    }
    const handleRawExcelDataSubmit = () => {
        if (rawExcelData === '') {
            setExcelDataFormIsEmpty('block');
        }
        else {
            setLoadingExcelImport(true);
            setExcelDataFormIsEmpty('none');
            TransferAtSourceService.importExcelTransactions(formData, rawExcelData, false).then(
                (response) => {
                    if (response.data.hasFatalError === true || response.data.hasWarningError === true) {
                        setOpenImportExcelErrorDialog(true);
                        setErrorsExcelImport(response.data.errors);
                        setHasErrors({ warning: response.data.hasWarninfError, fatal: response.data.hasFatalError })
                        if (response.data.hasFatalError === false && response.data.hasWarningError === true) {
                            setDialogErrorMessage({
                                title: 'Excel Import Warning errors',
                                text1: 'Click on the "EDIT EXCEL DATA" button and edit the input if needed.',
                                text2: 'Click on the "CONFIRM" button if you want to import those data',
                                color: 'warning'
                            });
                            setSubmitButton({ disabled: false, loading: false });
                        }
                        else if (response.data.hasFatalError === true) {
                            setDialogErrorMessage({
                                title: 'Excel data errors',
                                text1: 'Fatal Data errors in the Excel sheet prevent their import.',
                                text2: 'Please correct the errors and resubmit',
                                color: 'error'
                            });
                            setSubmitButton({ disabled: false, loading: false });
                        }
                    }
                    else {
                        setTransactions(response.data.transactions);
                        setFilteredTransactions(response.data.transactions);
                        setOpenImportExcelDialog(false);
                        setSubmitButton({ disabled: false, loading: false });
                        setRawExcelData("");
                    }
                    setLoadingExcelImport(false);
                });
        }
    }
    const handleSubmitAfterWarning = () => {
        setSubmitButtonAfterWarning({ disabled: true, loading: true });
        TransferAtSourceService.importExcelTransactions(formData, rawExcelData, true).then(
            (response) => {
                setTransactions(response.data.transactions);
                setFilteredTransactions(response.data.transactions);
                setErrorsExcelImport(response.data.errors);
                setHasErrors({ warning: response.data.hasWarninfError, fatal: response.data.hasFatalError })
                setOpenImportExcelDialog(false);
                setOpenImportExcelErrorDialog(false)
                setRawExcelData("");
                setSubmitButtonAfterWarning({ disabled: false, loading: false });
                setSubmitButton({ disabled: false, loading: false });
                setLoadingExcelImport(false);
            });
    };
    const handleAutoCompleteChange = (target, fieldName) => {
        var value = target !== null ? target.value : ''
        var text = target !== null ? target.text : ''
        formik.setFieldValue([fieldName], value);
        if (fieldName === 'plant') {
            var newStorageLocationList = dropdownItemsStore["sapStorageLocation"].filter(function (location) {
                return location.plant === value;
            });
            setDropdownStorageLocation(newStorageLocationList);
            setAutocompleteData({ ...autocompleteData, plant: { text, value }, storage: { text: '', value: '' } });
            setFormData({ ...formData, plant: value, storage: '' });
        }
        else {
            setAutocompleteData({ ...autocompleteData, [fieldName]: { text: text, value: value } })
            setFormData({ ...formData, [fieldName]: value });
        }
    };
    const handleDateChange = (date: Date | null) => {
        formik.setFieldValue('loadingDate', date);
        setFormData({ ...formData, loadingDate: date });
    };
    const handleTableSearch = (event) => {
        const filteredRows = transactions.filter(item => {
            const query = event.target.value.toLowerCase();
            return (
                item.ticketId.toLowerCase().indexOf(query) >= 0 ||
                item.plantTo.toLowerCase().indexOf(query) >= 0 ||
                item.operationTeam.toLowerCase().indexOf(query) >= 0 ||
                item.materialNo.toLowerCase().indexOf(query) >= 0 ||
                item.truckNo.toLowerCase().indexOf(query) >= 0
            )
        });
        setFilteredTransactions(filteredRows)
    };
    const handleSearchSubmit = () => {
        let ticketsIds = transactions.map(function (item) {
            return item['ticketId'];
        });
        TransactionsService.getTransactionsByTicketsIds(ticketsIds).then(
            (response) => {
                setTransactions(response.data);
                setFilteredTransactions(response.data);
            });
    };
    const handleClearTextArea = () => {
        setRawExcelData("");
        setLoadingExcelImport(false);
    };
    const handleAddNew = () => {
        setEditTicketData({ ticketId: "", coTicketId: "", operationTeam: "", slocTo: "", plantTo: "", tankTo: "", batchNoTo: "", loadingDate: new Date().toISOString(), poNo: "", poItemNo: "", materialNo: "", vendorName: "", transportCom: "", truckNo: "", factoryName: "", vendorDoNo: "", vendorDoWeight: "", weightIn: "", weightOut: "", netWeight: "", slocFrom: "", plantFrom: "", tankFrom: "", batchNoFrom: "", createBy: "", createDate: null, modBy: "", modDate: null, status: "", sent: "", vehicleType: "", unit: "", materialName: "", comments: "", gainLoss: "", confirmWith: "", netWeightDest: "" })
        setOpenEditDialog(true);
    };
    const handleAddNewReload = () => {
        //setOpenEditDialog(close);
    };

    const handleChangeSelection = (selection) => {
        setSelectionModel(selection.selectionModel)
    };
    const handleChangeStatusSubmit = () => {
        setSubmitButton({ disabled: true, loading: true })
        let map = transactions.map(obj => {
            return { ticketId: obj.ticketId, slocTo: obj.slocTo }
        });
        TransactionsService.changeStatusByTicketsId(map).then(
            (response) => {
                const data = response.data;
                setTransactions(data);
                setFilteredTransactions(data);
                setSuccessDialog({ isOpen: true, title: 'Status changed to Submit', subTitle: 'The ticket(s) has been submit succesfully' })
                setSubmitButton({ disabled: true, loading: false })
            });
    };
    return (
        <React.Fragment>
            <Container>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Box mt={3}>
                            <Button onClick={() => history.goBack()} variant="contained">Cancel</Button>
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Card className={classes.root}>
                            <CardHeader title="GENERAL DATA" />
                            <CardContent>
                                <Formik>
                                    <Form onSubmit={formik.handleSubmit}>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} sm={12} lg={9}>
                                                <Grid container spacing={1}>
                                                    <Grid item xs={12} sm={4}>
                                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                            <Grid container justify="space-around">
                                                                <KeyboardDatePicker
                                                                    disableToolbar
                                                                    autoOk={true}
                                                                    size="small"
                                                                    fullWidth
                                                                    inputVariant="outlined"
                                                                    format="dd/MM/yyyy"
                                                                    id="loadingDate"
                                                                    name="loadingDate"
                                                                    label="Loading Date"
                                                                    minDate={new Date(dateNow.getFullYear(), dateNow.getMonth() - 1, dateNow.getDate())}
                                                                    maxDate={new Date(dateNow.getFullYear(), dateNow.getMonth(), dateNow.getDate())}
                                                                    onChange={handleDateChange}
                                                                    value={formik.values.loadingDate}
                                                                    KeyboardButtonProps={{
                                                                        'aria-label': 'change date',
                                                                    }}
                                                                />
                                                            </Grid>
                                                        </MuiPickersUtilsProvider>
                                                    </Grid>
                                                    <Grid item xs={12} sm={4}>
                                                        <Autocomplete
                                                            id="operationTeamAutocomplete"
                                                            name="operationTeamAutocomplete"
                                                            closeIcon=""
                                                            options={dropdownItemsStore["operationTeam"]}
                                                            value={{ text: autocompleteData.operationTeam.text, value: autocompleteData.operationTeam.value }}
                                                            getOptionLabel={(option) => option.text}
                                                            renderOption={option => <>{option.text}</>}
                                                            onChange={(event, newValue) => {
                                                                handleAutoCompleteChange(newValue, 'operationTeam');
                                                            }}
                                                            renderInput={(params) => <TextField {...params}
                                                                id="operationTeamAutocomplete"
                                                                name="operationTeamAutocomplete"
                                                                label="Operation Team"
                                                                //placeholder={"Plants"}
                                                                size="small"
                                                                variant="outlined"
                                                                error={formik.touched.operationTeam && Boolean(formik.errors.operationTeam)}
                                                                helperText={formik.touched.operationTeam && formik.errors.operationTeam}
                                                            />}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12} sm={12} lg={3}>
                                                <Grid container spacing={1} style={{ textAlign: "center" }}>
                                                    <Grid item xs={12}>
                                                        <Button style={{ width: '100%' }} color="primary" variant="contained"
                                                            type="submit"
                                                        >IMPORT DATA</Button>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Form>
                                </Formik>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Card className={classes.root}>
                            <CardHeader
                                title="TRANSFER FROM EXTERNAL TO EXTERNAL AT DESTINATION "
                                action={
                                    <HtmlTooltip title={
                                        <React.Fragment>
                                            <Typography color="inherit">Title here</Typography>
                                            <span>{"Aliquam eget finibus ante, non facilisis lectus. Sed vitae dignissim est, vel aliquam tellus. Praesent non nunc mollis, fermentum neque at, semper arcu. Nullam eget est sed sem iaculis gravida eget vitae justo."}</span>
                                        </React.Fragment>
                                    }>
                                        <IconButton aria-label="settings">
                                            <HelpCircleOutline />
                                        </IconButton>
                                    </HtmlTooltip>
                                }
                            />
                            <CardContent>
                                <Grid container spacing={3}>
                                    <Grid item xs={6}>
                                        {allowAction("20101", "submit") ?
                                            <Box component="span" mr={1} className={classes.buttonWrapper}>
                                                <Button disabled={submitButton.disabled} onClick={handleChangeStatusSubmit} variant="contained">Submit</Button>
                                                {submitButton.loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                                            </Box>
                                            : null}
                                        {allowAction("20101", "create") ?
                                            <Button onClick={handleAddNew} variant="contained" color="primary">Add</Button>
                                            : null}
                                    </Grid>
                                    <Grid item xs={6} style={{ textAlign: "right" }}>
                                        <FormControl className={clsx(classes.margin, classes.textField)} variant="outlined" size="small">
                                            <InputLabel htmlFor="search">Search</InputLabel>
                                            <OutlinedInput
                                                id="search"
                                                endAdornment={
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="search"
                                                            //onClick={handleTableSearch}
                                                            edge="end"
                                                        >
                                                            <Magnify />
                                                        </IconButton>
                                                    </InputAdornment>
                                                }
                                                labelWidth={70}
                                                onChange={handleTableSearch}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <div className={classes.materialReceivingTable} style={{ width: '100%' }}>
                                            <DataGrid
                                                className={classes.table}
                                                rows={rows}
                                                autoHeight={true}
                                                disableColumnMenu={true}
                                                disableColumnSelector={true}
                                                disableSelectionOnClick={true}
                                                columns={columns}
                                                getRowId={(row) => row.ticketId}
                                                selectionModel={selectionModel}
                                                onSelectionModelChange={handleChangeSelection}
                                            />
                                        </div>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Container >
            <Dialog
                fullWidth={true}
                maxWidth={'lg'}
                open={openImportExcelDialog}
                onClose={handleImportExcelDialogClose}
                aria-labelledby="form-dialog-title">
                <DialogTitle
                    id="form-dialog-title">
                    <Grid container>
                        <Grid item xs={6}>
                            Import Data
                                </Grid>
                        <Grid item xs={6} style={{ textAlign: "right" }}>
                            <HtmlTooltip title={
                                <React.Fragment>
                                    <Typography color="inherit">Import Excel data</Typography>
                                    <span>{"Excel data must be separated by a "}</span> <b>{"Tab"}</b> <span>{"(automaticly generated with Excel) or a semicolon"}</span> <b>{";"}</b>
                                </React.Fragment>
                            }>
                                <IconButton aria-label="settings">
                                    <HelpCircleOutline />
                                </IconButton>
                            </HtmlTooltip>
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent>
                    <Box display={excelDataFormIsEmpty}>
                        <Typography color="error">You must add some Excel data</Typography>
                    </Box>
                    <TextareaAutosize value={rawExcelData} onChange={event => setRawExcelData(event.target.value)} style={{ width: "100%", whiteSpace: "pre", overflowX: "scroll" }} aria-label="import data" rowsMin={10} placeholder="Copy and past your Excel data" />
                </DialogContent>
                <DialogActions>
                    <div className={classes.buttonWrapper}>
                        <Button disabled={loadingExcelImport} onClick={handleRawExcelDataSubmit} variant="contained" color="primary">Import</Button>
                        {loadingExcelImport && <CircularProgress size={24} className={classes.buttonProgress} />}
                    </div>
                    <Button onClick={handleClearTextArea} variant="contained">Clear</Button>
                    <Button onClick={handleImportExcelDialogClose} variant="contained">Cancel</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                fullWidth={true}
                maxWidth={'lg'}
                open={openImportExcelErrorDialog}
                onClose={handleImportExcelErrorDialogClose}
                aria-labelledby="form-dialog-title">
                <DialogTitle
                    id="form-dialog-title">
                    <Grid container>
                        <Grid item xs={6}>
                        </Grid>
                        <Grid item xs={6} style={{ textAlign: "right" }}>
                            <HtmlTooltip title={
                                <React.Fragment>
                                    <Typography color="inherit">Import Excel errors</Typography>
                                    <span>{"Please correct the following error(s)"}</span>
                                </React.Fragment>
                            }>
                                <IconButton aria-label="settings">
                                    <HelpCircleOutline />
                                </IconButton>
                            </HtmlTooltip>
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent className={classes.dialogMessage}>
                    <Box className={clsx('dialog-message', { error: dialogErrorMessage.color === 'error', warning: dialogErrorMessage.color === 'warning' })}>
                        <Box mb={1}>
                            <Typography variant="h5" align="center">{dialogErrorMessage.title}</Typography>
                        </Box>
                        <Typography variantMapping="div" align="center">{dialogErrorMessage.text1}</Typography>
                        <Box mb={2} align="center">
                            <Typography variantMapping="div" align="center">{dialogErrorMessage.text2}</Typography>
                        </Box>
                    </Box>
                    <CollapsibleTable errorsExcelImport={errorsExcelImport} />
                </DialogContent>
                <DialogActions>
                    <div className={classes.buttonWrapper}>
                        <Button onClick={handleImportExcelErrorDialogClose} variant="contained" color="default">Close</Button>
                        <Box component="span" pl={1} className={classes.buttonWrapper}>
                            <Button onClick={handleImportExcelErrorDialogClose} variant="contained" color="primary">Edit Excel data</Button>
                        </Box>
                        {hasErrors.fatal === true ? '' :
                            <Box component="span" pl={1} className={classes.buttonWrapper}>
                                <ActionButton
                                    text="Confirm"
                                    color="warning"
                                    onClick={handleSubmitAfterWarning}
                                    disabled={submitButtonAfterWarning.disabled}
                                    variant="contained"
                                />
                                {submitButtonAfterWarning.loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                            </Box>}
                    </div>
                </DialogActions>
            </Dialog>
            {openEditDialog ?
                <TransferAtSourceEdit handleSearchSubmit={handleSearchSubmit} handleAddNewReload={handleAddNewReload} transactions={transactions} setTransactions={setTransactions} transactionData={editTicketData} setFilteredTransactions={setFilteredTransactions} open={openEditDialog} onClose={handleEditDialogClose} /> : ''
            }
            <ConfirmDialog
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
            />
            <SuccessDialog successDialog={successDialog}
                setSuccessDialog={setSuccessDialog}
            />
            <Backdrop className={classes.backdrop} open={isLoading}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </React.Fragment >
    );
}
const useStyles = makeStyles((theme) => ({
    root: {
    },
    materialReceivingTable: {
        '& .MuiDataGrid-columnsContainer': {
            backgroundColor: '#86C1D4',
        },
        minWidth: 650,
        '& .import-from-excel-table.error': {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.error.contrastText,
        },
        '& .import-from-excel-table.success': {
            backgroundColor: theme.palette.success.main,
            color: theme.palette.success.contrastText,
        },
        '& .import-from-excel-table--header': {
            backgroundColor: '#86C1D4',
            color: 'white',
            fontWeight: 'bold',
        },
        '& svg.MuiSvgIcon-root.MuiDataGrid-iconSeparator': {
            display: 'none'
        }
    },
    dialogMessage: {
        '& .dialog-message.warning': {
            color: orange[600]
        },
        '& .dialog-message.error': {
            color: red[600]
        },
    },
    table: {
        minWidth: 650,
    },
    addMaterialReceiving: {
        textAlign: 'center',
    },
    buttonProgress: {
        color: '#2E94B9',
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    buttonWrapper: {
        position: 'relative',
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
    },
}));
const useRowStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            borderBottom: 'unset',
        },
    },
    headerTable: {
        backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[600],
    },
    tableResult: {
        marginTop: 10,
        marginBottom: 10
    },
    tableResultHead: {
        backgroundColor: theme.palette.background.paper,
    },
    tableResultRow: {
        '& .result-table.error': {
            backgroundColor: theme.palette.type === 'light' ? red[50] : theme.palette.error.dark,
        },
        '& .result-table.warning': {
            backgroundColor: theme.palette.type === 'light' ? orange[50] : theme.palette.warning.dark,
        }
    }
}));
function Row(props) {
    const { row } = props;
    const [open, setOpen] = React.useState(true);
    const classes = useRowStyles();
    return (
        <React.Fragment>
            <TableRow className={clsx(classes.root, classes.headerTable)}>
                <TableCell width="20px">
                    <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                        {open ? <ChevronUp /> : <ChevronDown />}
                    </IconButton>
                </TableCell>
                <TableCell align="left" colSpan={3}>
                    Excel Line {row.line + 1}
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={4}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box margin={0}>
                            {
                                row.lineError !== null
                                    ? <Box>
                                        <Table className={classes.tableResult} size="small" aria-label="errors">
                                            <TableBody className={classes.tableResultRow}>
                                                {row.lineError.map((lineError) => (
                                                    <TableRow className={clsx('result-table', 'error')}
                                                        key={row.line}>
                                                        <TableCell>
                                                            {lineError}
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </Box>
                                    : <Table className={classes.tableResult} size="small" aria-label="errors">
                                        <TableHead>
                                            <TableRow className={classes.tableResultHead}>
                                                <TableCell width="15%">Error Type</TableCell>
                                                <TableCell width="15%">Column Name</TableCell>
                                                <TableCell width="10%">Cell Number</TableCell>
                                                <TableCell width="25%">Value</TableCell>
                                                <TableCell width="35%">Error Message</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody className={classes.tableResultRow}>
                                            {row.cellError.map((cellError) => (
                                                <TableRow className={
                                                    clsx('result-table', { error: cellError.errorType === 'fatal', warning: cellError.errorType === 'warning' })
                                                }
                                                    key={cellError.line}>
                                                    <TableCell component="th" scope="row">
                                                        {cellError.errorType === 'warning' ? 'Warning' : 'Fatal'}
                                                    </TableCell>
                                                    <TableCell component="th" scope="row">
                                                        {cellError.columnName}
                                                    </TableCell>
                                                    <TableCell>{cellError.column + 1}</TableCell>
                                                    <TableCell>{cellError.value}</TableCell>
                                                    <TableCell>
                                                        {cellError.errors.map((errors) => (
                                                            <Box>{errors}</Box>
                                                        ))}
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                            }
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}
/**
* Move it to a componement!
*/
function CollapsibleTable(props) {
    const { errorsExcelImport } = props;
    return (
        <TableContainer component={Paper}>
            <Table size="small" aria-label="collapsible table">
                <TableBody>
                    {errorsExcelImport.map((row) => (
                        <Row key={row.line} row={row} />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
